import SentimentSummary from "./SentimentSummary";

export default SentimentSummary;
